function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, string } from 'prop-types';
import clsx from 'clsx';
import Toolbar, { toolbarClasses } from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
const StyledToolbar = styled(Toolbar)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  const border = "1px solid ".concat(palette.divider);
  return {
    ["&.".concat(toolbarClasses.root)]: {
      backgroundColor: palette.background.default,
      borderBottom: border,
      borderTop: border,
      boxSizing: 'border-box',
      display: 'flex',
      height: spacing(6),
      minHeight: spacing(6),
      padding: 0,
      width: '100%'
    }
  };
});
const SovosToolbar = _ref2 => {
  let {
    children,
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledToolbar, _extends({
    className: clsx('sovosToolbar', className)
  }, rest), children);
};
SovosToolbar.propTypes = {
  /**
   * Contents of the `SovosToolbar` component:
   *
   * - `SovosToolbarTitle`, `SovosToolbarActions`, `SovosToolbarBulkActions`,
   *   or `SovosToolbarDataGrouping`
   * - To add custom elements to the toolbar, wrap them in a `SovosToolbarGroup`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosToolbar.baseComponent = {
  name: 'Toolbar',
  link: 'toolbar/'
};
export default SovosToolbar;